import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../../API/axiosNeatex';
import type { APIResponse } from '../../../Shared/shared';

interface SessionsNeedSettlementModel {
  id: string;
  posId: string;
  endDatetime: string;
  confirmed: boolean;
  casherId: string;
  casherName: string;
  casherName2: string;
  posName: string;
  posName2: string;
  openDate: string;
  closeDate: string;
  status: null;
  expectedTotal: number;
  actualTotal: number;
  differenceTotal: number;
  payments: {
    paymentMethodId: string;
    paymentMethodName: string;
    paymentMethodName2: string;
    expectedAmount: number;
    actualAmount: number;
    differenceAmount: number;
    note: string;
  }[];
}

// export const getPosSessionsNeedSettlementList = createAsyncThunk(
//   'SessionSettlement/getPosSessionsNeedSettlementList',
//   async (_, { rejectWithValue }: { rejectWithValue?: any } = {}) => {
//     try {
//       const { data } = await ntxAPI.get('Pos/GetPosSessionsNeedSettlementList');
//       if (data?.succeeded) {
//         return data.data;
//       } else {
//         return rejectWithValue(data?.message || 'هناك خطأ');
//       }
//     } catch (error: any) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

export const getPosSessionsNeedSettlementList = createAsyncThunk(
  'SessionSettlement/getPosSessionsNeedSettlementList',
  async (params: any | undefined, { rejectWithValue }: { rejectWithValue?: any } = {}) => {
    try {
      const queryParams = {
        // لازم الأسماء تطابق Swagger حرفياً
        PosId: params?.posId || undefined,
        BranchId: params?.branchId || undefined,
        FromDate: params?.fromDate || undefined,
        ToDate: params?.toDate || undefined
      };

      const { data } = await ntxAPI.get('Pos/GetPosSessionsNeedSettlementList', {
        params: queryParams
      });

      if (data?.succeeded) {
        return data.data;
      } else {
        return rejectWithValue(data?.message || 'هناك خطأ');
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const bulkProcessPosSettlement = createAsyncThunk(
  'SessionSettlement/bulkProcessPosSettlement',
  async (payload: any, { rejectWithValue }: { rejectWithValue?: any } = {}) => {
    try {
      const { data } = await ntxAPI.post('Pos/BulkProcessPosSettlement', payload);
      if (data?.succeeded) return data;
      return rejectWithValue(data?.message || 'هناك خطأ');
    } catch (error: any) {
      return rejectWithValue(error?.message || 'Network error');
    }
  }
);

export const getPosSessionForSettlementById = createAsyncThunk(
  'SessionSettlement/getPosSessionForSettlementById',
  async (sessionId: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get<APIResponse<SessionsNeedSettlementModel>>(
        `Pos/GetPosSessionForSettlementById?SessionId=${sessionId}`
      );
      if (data.succeeded) {
        return data.data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const saveSessionSettlementDraft = createAsyncThunk(
  'SessionSettlement/saveSessionSettlementDraft',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post<APIResponse<any>>(`Pos/SaveSessionSettlementDraft`, item);

      return data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
export const updateSessionPayment = createAsyncThunk(
  'SessionSettlement/updateSessionPayment',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post<APIResponse<any>>(`Pos/UpdateSessionPayment`, item);

      return data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

type State = {
  SessionsNeedSettlementList: SessionsNeedSettlementModel[];
  loading: boolean;
  error: string | null;
  //
  SessionForSettlement: SessionsNeedSettlementModel;
  loading2: boolean;
  error2: string | null;
  //
  bulkLoading: boolean;
  bulkError: null;
  bulkResult: null;
};

const initialState: State = {
  SessionsNeedSettlementList: [],
  loading: false,
  error: null,
  //
  SessionForSettlement: {} as SessionsNeedSettlementModel,
  loading2: false,
  error2: null,
  //
  bulkLoading: false,
  bulkError: null,
  bulkResult: null
};

const SessionSettlementSlice = createSlice({
  name: 'SessionSettlement',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getPosSessionsNeedSettlementList.pending, state => {
        state.loading = true;
      })
      .addCase(
        getPosSessionsNeedSettlementList.fulfilled,
        (state, action: PayloadAction<SessionsNeedSettlementModel[]>) => {
          state.loading = false;
          state.SessionsNeedSettlementList = action.payload;
        }
      )
      .addCase(getPosSessionsNeedSettlementList.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })
      //
      .addCase(getPosSessionForSettlementById.pending, state => {
        state.loading = true;
      })
      .addCase(
        getPosSessionForSettlementById.fulfilled,
        (state, action: PayloadAction<SessionsNeedSettlementModel>) => {
          state.loading = false;
          state.SessionForSettlement = action.payload;
        }
      )
      .addCase(getPosSessionForSettlementById.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })
      //
      .addCase(bulkProcessPosSettlement.pending, (state: any) => {
        state.bulkLoading = true;
        state.bulkError = null;
        state.bulkResult = null;
      })
      .addCase(bulkProcessPosSettlement.fulfilled, (state: any, action: any) => {
        state.bulkLoading = false;
        state.bulkResult = action.payload;
      })
      .addCase(bulkProcessPosSettlement.rejected, (state: any, action: any) => {
        state.bulkLoading = false;
        state.bulkError = action.payload || action.error?.message;
      });
  }
});

export default SessionSettlementSlice.reducer;
